/**
 * @generated SignedSource<<84e9994ae91dfeb6a8417e2a29783fd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePreloadedDuties_buyer$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "usePreloadedDuties_buyer";
};
export type usePreloadedDuties_buyer$key = {
  readonly " $data"?: usePreloadedDuties_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePreloadedDuties_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePreloadedDuties_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "978adc58dc5d4154eeaba5f4dfdad50e";

export default node;
